export default __webpack_public_path__ + "398271c6dea4c967c9dbf9493bda7b91.png";